@if (!available && loaded) {
  <ngb-alert type="warning" [dismissible]="false">{{"REPLENISHMENT_NOT_AVAILABLE"|translate}}</ngb-alert>
}
